import Colcade from 'colcade';
import GLightbox from 'glightbox';

class PhotoGallery {
  constructor() {
    this._cacheSelectors();
    this._initColcade();
    this._initLightbox();
  }

  _cacheSelectors() {
    this._grids = document.querySelectorAll('.photogallery-grid');
    this._lightboxItems = document.querySelectorAll('.gallery a');
  }

  _initColcade() {
    this._grids.forEach((grid) => {
      this.colc = new Colcade(grid, {
        columns: '.grid-col',
        items: '.grid-item',
      });
    });
  }

  _initLightbox() {
    this.lightbox = GLightbox();
  }
}

export default PhotoGallery;
